import moment from "moment";
import { useMemo } from "react";
import { DateRange, GraphTimePeriod } from "../services/device-mileage-utils.ts";

const useDateRangeForTimePeriod = (period: GraphTimePeriod): DateRange => {
  return useMemo(() => {
    switch (period) {
      case 'last_month':
        return {
          startAt: moment().subtract(1, 'month').startOf('month').utc().toDate(),
          endAt: moment().subtract(1, 'month').endOf('month').utc().toDate(),
        };
      case 'this_month':
        return {
          startAt: moment().startOf('month').utc().toDate(),
          endAt: moment().endOf('month').utc().toDate(),
        };
      case 'last_week':
        return {
          startAt: moment().subtract(1, 'week').startOf('week').utc().toDate(),
          endAt: moment().subtract(1, 'week').endOf('week').utc().toDate(),
        };
      case 'this_week':
        return {
          startAt: moment().startOf('week').utc().toDate(),
          endAt: moment().endOf('week').utc().toDate(),
        };
      case 'yesterday':
        return {
          startAt: moment().subtract(1, 'day').startOf('day').utc().toDate(),
          endAt: moment().subtract(1, 'day').endOf('day').utc().toDate(),
        };
      case 'today':
      default:
        return {
          startAt: moment().startOf('day').utc().toDate(),
          endAt: moment().endOf('day').utc().toDate(),
        };
    };
  }, [period]);
}

export {
  useDateRangeForTimePeriod
};
